import{base64UrlToString}from"./helpers";export const decodeJWTTokenPayload=token=>JSON.parse(base64UrlToString(token.split(".")[1]));